// Canonical normalization functions
// PRESERVED EXACT COMPLIANCE with original src/utils.js

export const normalize = (str) => {
    if (!str && str !== 0) return "";
    let s = String(str).toLowerCase();
    // Transliterate common Cyrillic look-alikes to Latin
    s = s.replace(/а/g, 'a');
    s = s.replace(/с/g, 'c');
    s = s.replace(/е/g, 'e');
    s = s.replace(/о/g, 'o');
    s = s.replace(/р/g, 'p');

    const cleanStr = s.replace(/[^a-z0-9]/g, '');
    const letters = (cleanStr.match(/[a-z]/g) || []).sort().join('');
    const numbers = (cleanStr.match(/[0-9]/g) || []).join('');
    return numbers + letters;
};

// Phones are not normalised here: the one rule is src/utils/phoneUtils.js (phoneDigits keeps the
// country code; formatPhone / whatsappUrl show and link it - owner, 27 Sep 2026).
